export enum AssignmentHiddenColumns {
  Customer = 'customer',
  CustomerId = 'customerId',
}
